import { Moment } from "moment";
import {AllocationState} from "@/api/types";

export class ShippingOrderModel {
[x: string]: any;
  id: string;
  shippingCode: string;
  abbreviation: string;
  startDate: Moment;
  inShippingSpaceState: string;
  billLadingCode: string;
  containerTypeList: ShippingOrderContainerTypeModel[];
  boxNumber: string;
  sealNo: string;
  allocationStatus: AllocationState;
  generatedCustomsDeclarationContract: string;
}

export class ShippingOrderContainerTypeModel {
  id: string;
  code: string;
  containerNumber: string;
  containerTypeCode?: string;
  loadingInOneOrMorePlaces: string;
  name: string;
  sealNumber: string;
  value: string;
  volume: string;
  containerInfo: string;
  loadingPlanCode: string;
  remark: string;
}
